export default {
    namespaced: true,
    state: {
        organisation: {},
        apps: []
    },
    getters: {
        organisation(state) {
            return state.organisation;
        },
        apps(state) {
            return state.apps;
        }
    },
    actions: {
        async fetch() {},
        async fetchApps() {}
    },
    mutations: {
        SET_ORGANISATION(state, data) {
            state.organisation = data;
        },
        SET_APPS(state, data) {
            state.apps = data;
        }
    }
};
